import GradingIcon from "@mui/icons-material/Grading";
import { Grid } from "@mui/material";
import { Button, SelectInput, required, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { DoctoralSchoolResultChoices } from "utils/choices";

const ResultDialog = ({ doctorantId, currentResult }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.recordDoctoralSchoolResult(doctorantId),
      { result: data.result },
      "POST",
    );
    notify("Резултатът е записан успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Резултат от докторантско училище"
      saveTitle="Запази"
      dialogSize="sm"
      onConfirm={handleConfirm}
      defaultValues={{ result: currentResult ?? null }}
      triggerButton={
        <Button
          label={currentResult ? "Промени резултат" : "Въведи резултат"}
          startIcon={<GradingIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
        >
          <SelectInput
            source="result"
            label="Резултат"
            choices={DoctoralSchoolResultChoices}
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default ResultDialog;
